export enum DataPermissionByCountry {
  DE_DATA = "DE_DATA",
  FR_DATA = "FR_DATA",
}
